let redirectToLogin = null;

export const registerSessionRedirect = (fn) => {
  redirectToLogin = fn;
  return () => {
    if (redirectToLogin === fn) redirectToLogin = null;
  };
};

// Clears the session and sends the user to /login without a full page reload.
export const handleSessionExpired = () => {
  // Nothing stored means the user already logged out; late 401s from in-flight requests must not redirect again.
  if (!localStorage.getItem('token') && !localStorage.getItem('user')) return;

  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('auth_role');
  localStorage.removeItem('user_id');
  window.dispatchEvent(new Event('auth:logout'));

  if (redirectToLogin) redirectToLogin();
  else window.location.href = '/login';
};
